import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const IntentionPlaceholder = (): ReactNode => (
  <Placeholder testID={TEST_ID.INTENTIONS.CARD.LOADING} className="flex-col">
    <View className="flex-row items-center">
      <PlaceholderMedia />
      <PlaceholderLine className="ml-2 max-w-36" />
    </View>
    <PlaceholderLine className="mt-2 max-w-80" />
    <PlaceholderLine className="mt-4 max-w-36" />
  </Placeholder>
)
